import { Button, Row, Form } from 'react-angle-dashboard-components'
import styled from 'styled-components'

export const WrapperSection = styled.header`
  background: #f2f5f9;
  height: 216px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  padding: 10px;
`

export const Title = styled.h1`
  font-family: Sentinel;
  font-weight: 600;
  font-size: 45px;
`

export const SmallBoldTitle = styled.h2`
  font-family: Sentinel;
  font-weight: 600;
  font-size: 30px;
  padding-bottom: 30px;
`

export const SmallTitle = styled.h2`
  font-family: Sentinel;
  font-size: 30px;
  margin-bottom: 40px;
`
export const SubTitle = styled.h3`
  font-family: Sentinel;
  font-size: 24px;
  margin-bottom: 20px;
`

export const FormLabel = styled(Form.Label)`
  font-weight: 600;
  font-weight: 18px;
`

export const FormControl = styled(Form.Control)`
  background: white;
`

// TODO make green
export const GreenButton = styled(Button)`
  padding-top: 9px;
  padding-bottom: 9px;
`

export const ExpirationBanner = styled.div`
  background: #fef4d8;
  border-radius: 6px;
  padding: 20px;
`

export const NotFoundCard = styled.div`
  background: #f2f5f9;
  border-radius: 6px;
  padding: 20px;
`

export const ResultCard = styled.div`
  background: #f2f5f9;
  border-radius: 6px;
  padding: 20px;
`

export const CardRow = styled(Row)`
  min-width: auto;
  & > div {
    margin-bottom: 0.6em;
    flex-basis: auto;
    width: 45%;
  }

  @media (min-width: 992px) {
    & > div {
      width: auto;
    }
  }
`

export const DataGrid = styled.div`
  display: grid;
  border: 1px solid #e7eaf3;
  border-radius: 8px;
  column-gap: 50px;
  row-gap: 10px;
  grid-template-columns: repeat(5, 1fr);
  padding: 14px 19px;
  width: 100%;
`

// unused

export const MainSection = styled.section`
  background: white;
`

export const searchBarStyles = {
  bar: {
    height: '3em',
    paddingTop: '1px',
    paddingRight: '1px',
    paddingBottom: '1px'
  }
}

export const SearchButton = styled(Button)`
  width: 100%;
  height: 3.1em;
  margin-top: 0.8em;
  @media (min-width: 768px) {
    width: 100px;
    margin-top: 0;
  }
`
